import Vue from 'vue'

export default {
  deleteProgramme({ id }) {
    return Vue.http.delete(`programme/${id}`)
    // console.log({ id })
    // return { status: 200 }
  },
};
